import { Page } from "../core/Page"
import Cart from "../sections/cart"
import Search from "../sections/search"
import Blog from "../sections/blog"
import Featured from "../sections/featured"
import Samples from "../sections/samples"
import OurPromise from "../sections/our-promise"
import Menu from "../components/Menu"
import AllProducts from "../sections/all-products"
import TradeForm from "../sections/trade-form"
import ContactForm from "../sections/contact-form"
import ShopAllSamples from "../sections/shop-all-samples"
import ShopAll from "../sections/shop-all"
import Sustainable from "../sections/sustainable"
import NewArrivals from "../sections/new-arrivals"
import Story from "../sections/story"
import Visualizer from "../sections/visualizer"
import Editorial from "../sections/editorial"
import BasedIn from "../sections/based-in"
import HeroHome from "../sections/hero-home"
import HeroText from "../sections/hero-text"
import LongTextImages from "../sections/long-text-images"
import SideBySideText from "../sections/side-by-side-text"
import StoryImage from "../sections/story-image"
import Benefits from "../sections/benefits"
import LoyaltyProgram from "../sections/loyalty-program"
import Voucher from "../sections/voucher"
import SupportCategories from "../sections/support-categories"
import AllArticles from "../sections/all-articles"
import HeroBlog from "../sections/hero-blog"
import MainArticle from "../sections/main-article"
import HeroArticle from "../sections/hero-article"
import Footer from "../sections/footer"
import HeroCollection from "../sections/hero-collection"
import HeroProduct from "../sections/hero-product"
import Quotes from "../sections/quotes"
import AnnouncementBar from "../sections/announcement-bar"
import ProductVideo from "../sections/product-video"
import SliderReview from "../sections/slider-review"
import SingleReview from "../sections/single-review"
import Dropdown from "../sections/dropdown"
import ProductInfo from "../sections/product-info"

export default class PageDefault extends Page {
  constructor(obj) {
    super(obj)

    const components = [
      { name: "menu", instance: Menu, hasTick: true },
      { name: "cart", instance: Cart },
      { name: "search", instance: Search },
      { name: "blog", instance: Blog, hasTick: true },
      { name: "featured", instance: Featured },
      { name: "samples", instance: Samples },
      { name: "ourPromise", instance: OurPromise },
      { name: "heroCollection", instance: HeroCollection, hasTick: true },
      { name: "allProducts", instance: AllProducts },
      { name: "tradeForm", instance: TradeForm },
      { name: "contactForm", instance: ContactForm },
      { name: "shopAllSamples", instance: ShopAllSamples },
      { name: "shopAll", instance: ShopAll },
      { name: "sustainable", instance: Sustainable },
      { name: "newArrivals", instance: NewArrivals },
      { name: "story", instance: Story },
      { name: "visualizer", instance: Visualizer },
      { name: "editorial", instance: Editorial },
      { name: "basedIn", instance: BasedIn },
      { name: "heroHome", instance: HeroHome },
      { name: "heroText", instance: HeroText },
      { name: "longTextImages", instance: LongTextImages },
      { name: "sideBySideText", instance: SideBySideText },
      { name: "storyImage", instance: StoryImage },
      { name: "benefits", instance: Benefits },
      { name: "loyaltyProgram", instance: LoyaltyProgram },
      { name: "voucher", instance: Voucher },
      { name: "supportCategories", instance: SupportCategories },
      { name: "allArticles", instance: AllArticles },
      { name: "heroBlog", instance: HeroBlog },
      { name: "mainArticle", instance: MainArticle },
      { name: "heroArticle", instance: HeroArticle },
      { name: "footer", instance: Footer },
      { name: "quotes", instance: Quotes },
      { name: "announcementBar", instance: AnnouncementBar },
      { name: "heroProduct", instance: HeroProduct },
      { name: "productVideo", instance: ProductVideo },
      { name: "singleReview", instance: SingleReview },
      { name: "sliderReview", instance: SliderReview },
      { name: "dropdown", instance: Dropdown },
      { name: "productInfo", instance: ProductInfo },
    ]

    this.components.push(...components)
  }
}
